import { Platform } from 'react-native'
import { JDJumping } from '@jdreact/jdreact-core-lib'
const isWeb = !!(Platform.OS === 'web')
let uaWeb = null
if (isWeb) {
	let ua = (navigator && navigator.userAgent) || ''
	uaWeb = ua.toLowerCase()
}

function getProcessedHouseShopInfo(shopInfo) {
	if (shopInfo) {
		const { longitude, latitude, bussinessBeginTime, bussinessEndTime } = shopInfo
		let latLon = {}
		if (longitude && latitude) {
			latLon = {
				lat: Number(latitude),
				lon: Number(longitude)
			}
		}
		let bussinessTimeStr = ''
		if (bussinessBeginTime && bussinessEndTime) {
			bussinessTimeStr = `${bussinessBeginTime} - ${bussinessEndTime}`
		}
		return {
			...shopInfo,
			latLon,
			bussinessTimeStr
		}
	}
	return null
}

function getLatLon(latLonStr) {
	if (latLonStr) {
	  const latLonArr = latLonStr.split(',')
		if (latLonArr && latLonArr.length > 1) {
		  return {
		  	lat: parseFloat(latLonArr[0], 10),
				lon: parseFloat(latLonArr[1], 10)
			}
		}
		return {}
	}
	return {}
}

// 是不是京东app中打开的h5页
function isJDAppWeb() {
	return !!(isWeb && uaWeb.indexOf('jdapp') !== -1)
}

// 跳转链接
function jumpToUrl(url) {
	let jumpUrl = url
	const isOpenapp= (jumpUrl.slice(0,16).toLowerCase() === 'openapp.jdmobile') // 判断链接是否是openapp协议
	let funcName = isOpenapp ? 'jumpToOpenapp' : 'jumpToWeb'
	// 若是京东app端的h5页，链接不是open协议，处理成open协议
	if (isJDAppWeb() && !isOpenapp) {
		jumpUrl = `openapp.jdmobile://virtual?params={"category":"jump","des":"m","action":"to","url":"${encodeURIComponent(jumpUrl)}"}`
		funcName = 'jumpToOpenapp'
	}
	return JDJumping[funcName](jumpUrl)
}

export {
	getProcessedHouseShopInfo,
	jumpToUrl
}
